<template>
  <v-container>
    <v-card align="justify">
      <v-card-title class="headline primary white--text">
        Intrare
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-flex xs12>
            <v-img
                class="centrado ml-4 mr-4 mt-3 mb-3"
                :src="require('../../assets/Intrare.png')"
                height="250px"
                contain
            ></v-img>
          </v-flex>
        </v-row>
        <br>
        <div><h2>AVISO DE PRIVACIDAD</h2></div>
        <br>
        <div class="body-2">
          De conformidad con lo establecido en los artículos 15,16 y 17 de la Ley Federal de Protección de Datos Personales en posesión de los particulares, <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> con domicilio ubicado en Alberto Cossio No. 105 Interior 10A, Fraccionamiento Tangamanga, San Luis Potosí, S.L.P. C.P. 78269, pone a su disposición el siguiente aviso de privacidad.
        </div>
        <br>
        <div class="body-2">
          <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> es una empresa dedicada al desarrollo de sistema digitales (Software) destinados a controlar accesos a diversos polígonos, así mismo se ostenta bajo la marca comercial INTRARE, la cual es una marca registrada, así como el software o sistemas de los cuales son propietarios.
        </div>
        <br>
        <div class="body-2">
          <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> es responsable del uso y protección de los datos personales que se recaben por medio de los sistemas digitales desarrollados, así como los que se recaben directamente de clientes y proveedores ya sea por correo electrónico o cualquier otro medio, y en este sentido, atendiendo las obligaciones legales establecidas en la ley federal de protección de datos personales en posesión de los particulares, a través de este instrumento se informa a los titulares de los datos, la información que de ellos se recaba y los fines que se le darán a dicha información.
        </div>
        <br>
        <div class="body-2">
          El suscrito del presente Aviso, requerirá los datos personales necesarios para poder prestar los siguientes SERVICIOS:
        </div>
        <br>
        <div class="body-2">
          - Desarrollar y adaptar los servicios en base a las necesidades de cada cliente.<br>
          - Creación de una cuenta o perfil para poder acceder al sistema y a la aplicación móvil.<br>
          - Identificación de áreas donde operará el software.<br>
          - Identificación de los Usuarios que podrán hacer uso del sistema.
          - Interacción de usuarios en el sistema.<br>
          - Generar fichas técnicas.<br>
          - Generar información de la operación del sistema.<br>
          - Identificar errores y fallas en el sistema y la aplicación.<br>
          - Estadísticas
        </div>
        <br>
        <div class="body-2">
          En caso de que el Suscrito utilice los datos para cualquier otra actividad o servicio que no
          se relacione con las aquí señaladas, este estará obligado a comunicárselo con el fin de que
          el titular otorgue su consentimiento expreso.
        </div>
        <br>
        <div class="body-2">
          Los datos personales que se recaban serán utilizados para las siguientes finalidades, las cuales son necesarias para prestarle el mejor servicio. <br>FINALIDADES DE LA RECABACIÓN DE DATOS:
        </div>
        <br>
        <div class="body-2">
          <ul>
            <li>Acceso del usuario al sistema y a la aplicación.</li>
            <li>Creación de una cuenta.</li>
            <li>Generar invitaciones para visitantes.</li>
            <li>Dar acceso remoto a invitados.</li>
            <li>Identificación de cada usuario del sistema, necesario para una prestación de
                Servicios Personalizada acorde a las necesidades particulares de cada cliente.</li>
            <li>Creación de un expediente virtual interno de cada cliente.</li>
            <li>Obtener información complementaria con el propósito de que los servicios del
                sistema puedan cumplir satisfactoriamente.</li>
            <li>Interacción entre administradores del sistema, usuarios y visitantes.</li>
            <li>Mantener el registro de entradas y salidas por medio del sistema.</li>
            <li>Poder consultar bases de datos.</li>
            <li>Registro de la actividad del usuario en el sistema o en la aplicación móvil.</li>
            <li>Informe de errores o fallas de la aplicación.</li>
            <li>Integración con otras aplicaciones o sistemas con los que trabaja INTRARE.</li>
          </ul>
        </div>
        <br>
        <div class="body-2">
          Para llevar a cabo las finalidades descritas en el presente aviso de privacidad, se utilizarán los siguientes datos personales:<br>
          DATOS PERSONALES QUE SE RECABAN:
        </div>
        <div class="body-2">
          <ul>
            <li>Datos personales: Nombres, Apellidos, CURP, imágenes de Identificación Oficial
                (INE) ambas caras, comprobante de domicilio.</li>
            <li>Datos de contacto: Correo electrónico, Número de teléfono móvil, Domicilio.</li>
            <li>Datos Empresariales: Razón Social, RFC, Información General de la empresa, Constancia de SUA, Constancia de Situación Fiscal.</li>
            <li>Datos de dispositivos para acceso a la aplicación móvil: Marca, Modelo, Sistema Operativo, Ubicación.</li>
            <li>Datos de calendario: Fechas y Notas.</li>
          </ul>
        </div>
        <br>
        <div class="body-2">
          Así mismo, nuestra aplicación móvil podrá solicitar que se le de acceso a la siguiente información de su dispositivo:
        </div>
        <div class="body-2">
          <ul>
            <li>Permiso para acceder a la ubicación exacta del dispositivo.</li>
            <li>Permiso para acceder a la lista de contactos del dispositivo.</li>
            <li>Permiso para acceder a la cámara y galería del dispositivo.</li>
            <li>Permiso para acceder al control del micrófono.</li>
          </ul>
        </div>
        <br>
        <div class="body-2">
          La información que obtenga el Suscrito una vez que se otorguen estos permisos, será tratada de igual forma que los datos personales aquí señalados, apegándose a todas las medidas de seguridad descritas en el cuerpo del presente aviso.
        </div>
        <br>
        <div class="body-2">
          DATOS SENSIBLES. - El Suscrito recabará y tratará datos sensibles, que en su momento sean necesarios o convenientes para el desarrollo de los servicios profesionales que se le proporcionan. Los datos personales sensibles serán mantenidos y tratados con estricta seguridad y confidencialidad para fines relacionados con la prestación de servicios conforme a este aviso de privacidad y la legislación, reglamentos y normativa aplicable. <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> tomará medidas de seguridad y así mismo serán de estricta aplicación por los empleados que estén subordinados a él para prevenir la pérdida, uso indebido, alteración o divulgación ilegal de su información y datos personales.
        </div>
        <br>
        <div class="body-2">
          NÚMEROS DE TELÉFONOS Y CONTACTOS.- Una vez que el usuario otorgue al suscrito el acceso por medio de su aplicación móvil a su lista de contactos (Nombres /Números de Teléfono) almacenados en su dispositivo, este NO realizará copia alguna de los contactos almacenados.
        </div>
        <br>
        <div class="body-2">
          Los datos del contacto solo se utilizan cuando el usuario desea crear una invitación. La aplicación móvil seleccionará de su agenda el contacto que el Usuario esté buscando y autocompletará los campos de teléfono y nombre con los datos de contacto de este, creando la invitación correspondiente.  Con estos datos se puede identificar al invitado; el número de teléfono se usa para poder notificar al invitado y el nombre para identificarlo al momento del acceso.
        </div>
        <br>
        <div class="body-2">
          Una vez creada la invitación y notificado el invitado, <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> desecha la información del contacto, por lo que no almacena información alguna en sus servidores.
        </div>
        <br>
        <div class="body-2">
          <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> a través de su aplicación móvil, en ningún momento utilizará los datos de contacto para cualquier otro objetivo que no sea crear una invitación y notificarle la misma. <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> por NINGÚN MOTIVO utilizará la información del contacto para ofrecer servicios, enviar anuncios, enviar correos o cualquier otro tipo de publicidad.
        </div>
        <br>
        <div class="body-2">
          <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> no realiza copias de la lista de contactos del usuario y tampoco los transmite a terceros.
        </div>
        <br>
        <div class="body-2">
          El usuario en todo momento podrá retirar el permiso de acceder a sus contactos, esto por medio de su dispositivo móvil, accediendo a la configuración de la aplicación y entrando a la sección de permisos. Esto limitará algunas funciones de la aplicación móvil.
        </div>
        <br>
        <div class="body-2">
          POLÍTICAS DE USO IMAGEN PERSONAL DEL USUARIO Y VISITANTES .- <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> a través de su aplicación móvil solo solicitará al usuario y a los visitantes su imagen con el fin de poder identificarlos y que se pueda cumplir con los servicios del sistema. <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> a través de su aplicación móvil en ningún momento utilizará o divulgará la imagen del usuario y/o los invitados fuera de la aplicación móvil y/o su sistema.
        </div>
        <br>
        <div class="body-2">
          Así mismo <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> a través de su aplicación móvil por ningún motivo transmitirá a terceros la imagen del usuario y/o de los invitados, con fines diferentes al debido funcionamiento de la aplicación móvil.
        </div>
        <br>
        <div class="body-2">
          <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> a través de su aplicación móvil solo almacenará de forma permanente en sus servidores las imágenes de los Usuarios.
        </div>
        <br>
        <div class="body-2">
          <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> a través de su aplicación móvil almacenará de forma provisional las imágenes de los visitantes, con el fin de poder generar la invitación correspondiente, una vez que esta cumpla con su objetivo, se eliminará automáticamente, junto con la información del visitante.
        </div>
        <br>
        <div class="body-2">
          TRANSFERENCIA. -  Con fundamento en el Artículo 36 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> puede transferir los datos personales en su posesión a terceros subcontratados únicamente para los fines relacionados con los señalados en este aviso de privacidad y bajo la autorización expresa del Titular.
        </div>
        <br>
        <div class="body-2">
          En estos casos <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> obligará a esos terceros a mantener las medidas de seguridad, administrativas, técnicas y físicas necesarias para salvaguardar los datos personales contra daño, pérdida, alteración, destrucción o el uso, acceso o tratamiento no autorizados, así como a conducirse de acuerdo con el presente Aviso de Privacidad. El usuario en todo momento podrá solicitar información de los terceros subcontratados a los que se les transfiera sus datos personales, por medio de un correo electrónico a hola@intrare.app  o notificación por escrito dirigida a <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong>
        </div>
        <br>
        <div class="body-2">
          LIMITACIÓN DE USO Y DIVULGACIÓN DE DATOS PERSONALES, Y RECTIFICACIÓN DE LOS MISMOS Con fundamento en los Artículos 28 y 29 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, para limitar el uso de sus datos personales, o bien a fin de rectificarlos en caso de que estos sean inexactos, favor de enviar un correo electrónico a hola@intrare.app  o notificación por escrito dirigida a <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> en el que se señale la limitación al uso de sus datos deseada o bien la corrección que se les debe hacer de los mismos y el sentido de ésta.
        </div>
        <br>
        <div class="body-2">
          MEDIOS PARA REVOCAR CONSENTIMIENTO. - Con fundamento en los Artículos 28 y 29 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares,  en cualquier momento puede solicitar la revocación del consentimiento otorgado a <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> para tratar sus datos personales enviando una solicitud por escrito dirigida a <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> con correo electrónico hola@intrare.app o enviando una notificación por escrito dirigida a <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> al domicilio ubicado en Alberto Cossio No. 105 Interior 10A, Fraccionamiento Tangamanga, San Luis Potosí, S.L.P. C.P. 78269, en la que se detalle claramente los datos respecto de los que revoca su consentimiento.
        </div>
        <br>
        <div class="body-2">
          Para todos los usuarios que en fechas anteriores a la notificación o publicación del presente Aviso de Privacidad hayan proporcionado a <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> sus Datos Personales, ya sea mediante el llenado de los formularios para la obtención servicios o por cualquier otra forma o medio, les será dado a conocer el Aviso de Privacidad  para continuar llevando a cabo el Tratamiento de sus Datos Personales con base en las Finalidades del Tratamiento establecidas en el Aviso de Privacidad.
        </div>
        <br>
        <div class="body-2">
          NOTIFICACIÓN DE CAMBIOS AL AVISO DE PRIVACIDAD. -  El presente Aviso de Privacidad podrá ser modificado en cualquier momento para cumplir con actualizaciones legislativas, jurisprudenciales, políticas internas o cualquier otra causa a entera discreción de <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> En tal caso, las modificaciones estarán disponibles en Alberto Cossio No. 105 Interior 10A, Fraccionamiento Tangamanga, San Luis Potosí, S.L.P. C.P. 78269.
        </div>
        <br>
        <div class="body-2">
          Atentamente
        </div>
        <br>
        <div class="body-2">
          <strong>TECNOLOGÍAS EN ACCESOS CONTROLADOS S.A. DE C.V.</strong> Alberto Cossio No. 105
          Interior 10A, Fraccionamiento Tangamanga, San Luis Potosí, S.L.P. C.P. 78269
        </div>
        <br>
        <v-row>
          <v-flex xs6>
          </v-flex>
          <v-flex xs6>
            <v-img
                class="centrado ml-4 mr-4 mt-3 mb-3"
                :src="require('../../assets/Intrare.png')"
                height="150px"
                contain
            ></v-img>
          </v-flex>
        </v-row>
        <br>
        <div class="body-2">
          Última actualización: junio, 2023
        </div>
        <br>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'notice_privacy'
}
</script>

<style scoped>

</style>
